import { Kaseya365UpgradeState } from '@layout/kaseya-365/store/state/kaseya-365-upgrade.state';

export const kaseya365UpgradeState = [Kaseya365UpgradeState];
